import i18n from './index.js'
export default {//德语
  translateText: {
    shoppingcart: "Der einkaufswagen?",
    loginorrefisterText: "Einloggen/anmelden",
    logoutText: "Und loggen sie sich nicht ein.",
    personcenterText: "Eine zentrale.",
    placeholderText: "Wählen sie aus.",
    loginText: "Einloggen.",
    registerText: "anmelden",
    emailText: "Briefkasten",
    pwdText: "kennwort",
    forgetpwdText: "Du hast die kombination vergessen?",
    nameText: "namen",
    surnameText: "Nachname",
    mobileText: "Telefon",
    setPwdText: "Passwort festlegen",
    countryText: "Ein land.",
    company: "Firma",
    birthday:"Geburtstag",
    yearText:"Jahr",
    mouthText:"Monat",
    dayText:"Tag",
    confirmpwdText: "Passwort bestätigen",
    agreeText1: "Ich habe gelesen und stimme zu",
    agreeText2: "Betriebsbedingungen",
    agreeText3: "und",
    agreeText4: "Datenschutz",
    agreeText5: "Ich stimme zu, dass ein Teil meiner persönlichen Daten gemäß der Datenschutzerklärung im Ausland verarbeitet wird",
    emailplaceholder: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    subscribetitleText: 'Abonnieren sie unseren rundbrief',
    subscribeText: 'Abonnieren sie das',
    shareToText: 'Aber ich teile.',
    searchText: 'Suche läuft.',
    subtractmoneyText: "600 weniger. - ich weiß nicht.",
    magnanimitycouponText: "Der gutschein wartet, bis sie einzahlen",
    drawText: "Sofortige zahlung.",
    discountText: "Das ist viel billiger.",
    purchaseText: "Kaufen sie ihn sofort.",
    composecouponText: "Portfolio kaufen",
    manyDiscountsText: "Ich biete dir ein spezialangebot.",
    recommendtitleText: "Ich werde eine empfehlung aussprechen.",
    hotsaleproductyitleText: "Top marketing.",
    guessLiketitleText: "Ich wette, das gefällt dir.",
    NoDataText: "Eine vermutung nimmt man Von zeit zu zeit.",
    appraiseText: "Bericht.",
    certificate: "Gutschein",
    collectText: "Sammlung",
    addCartText: "in den Warenkorb",
    enterkeywordsText: "Stichworte eingeben.",
    useNowText: "Sofortige verwendung.",
    vouchernoText: "Die kartennummer.",
    placeholderyearText:"Das ist das jahr der wahl.",
    placeholdermouthText:"Wählen sie den monat.",
    placeholderdayText:"Tag der wahl.",
    // 优惠券页面
    breadcrumbItemText1: 'übersteigen',
    breadcrumbItemText2: 'Ebene',
    breadcrumbItemText3: 'groß',
    breadcrumbItemText4: 'gesegnet',
    breadcrumbItemText5: 'Segen',
    magnanimitydrawText: 'Der gutschein wartet, bis sie einzahlen',
    availablecouponstitleText: 'Bezugsfertig, nicht wahr?',
    drawbtnText: 'Empfangen.',
    universalText: 'General verstoßen.',
    useText: 'Verwenden.',
    limitText: 'für',
    fullText: 'mit',
    subtractText: 'auf',
    // 折扣
    discountitemText1: 'Und dann gibt`s noch rabatt. ,',
    discountitemText2: '(mysteriöse musik',
    // 组合
    commoditydiscountitemText1: 'Portfolio kaufen ,',
    commoditydiscountitemText2: 'Ich biete dir ein spezialangebot.',
    combinedpriceText: 'Was kann ich dir bieten?',
    economizeText: 'Sparen.',
    buynowText: "Kaufen sie ihn sofort.",
    // 产品
    ourproductsText: 'Produkte.',
    productcategoryText: 'Typ der produkte.',
    recommendtarText: 'Eine empfehlung?',
    newText: 'Neu.',
    salesvolumetarText: '16. Absatz',
    pricetarText: 'Dem preis?',
    // 博客
    blogmanagementText: "Ein small-blog.",
    latestblogsText: "Den neuesten blog.",
    relatedrlogsText: "Den relevanten blog.",
    priceIncreasecommentText: "Die analyse einreichen",
    commentsectionTtxt: "Die kommentarzone",
    participatingcommentsText: "Ich mache die befragung.",
    // 论坛
    postingText: "Postbote der post.",
    topicsText: "Ein motto?",
    replyText: "Danke. Return.",
    viewText: "Ich kontrolliere sie.",
    lastreplyText: "Letzter aufruf.",
    publishText: "Sie veröffentlichen.",
    placeholdertypeText: "Bitte wählen sie kategorie a",
    placeholdertitleText: "Geben sie den titel ein?",
    placeholdercontentsText: "Bitte geben sie den inhalt ein.",
    fromtopicText: "Von dem subjekt:",
    firstfloor: "Erster stock.",
    floorText: "Boden",
    fromText: "Von:",
    postreplyText: "Ich habe geantwortet.",
    // 个人中心 - 我的订单
    myorderText: "Meine bestellung.",
    mycommentsText: "Mein urteil.",
    mycollectionText: "Das sind alles zusammenstellungen.",
    couponText: "Für jede menge rabatte.",
    shippingaddressText: "Die adresse für den empfang.",
    myPostText: "Meine sticker",
    personalinformationText: "Persönliche informationen.",
    editText: "Make up",
    allordersText: "Alle bestellungen.",
    unpaidText: "Noch zu zahlen.",
    shippedText: "Transport klarmachen.",
    receivedText: "In empfang nehmen.",
    evaluatedText: "Der belohung abwarten.",
    baidText: "Ausgezahlt.",
    completedText: "Erfolgreich.",
    productinfText: "Informationen zu produkten",
    unitpricethText: "Pro ladung?",
    quantitythText: "Mengen.",
    actualpaymentthText: "Bestätigt.",
    transactionstatusthText: "Status der transaktion.",
    operationthText: "betrieb",
    ordernumberText: "Null.",
    orderdetailsText: "Order bitte.",
    cancelorderText: "Stornieren sie die bestellung.",
    confirmText: "Könnten?",
    cancelText: "korrekt",
    deleteordertitle: "Hast du die aktuelle bestellung gelöscht?",
    successfultradeText: "Erfolgreicher deal.",
    paymentText: "Ist eine vergütung.",
    confirmreceiptText: "Bestätige empfang.",
    nncommentText: 'Keine kommentar.',
    // 个人中心 - 我的评论
    productText: "Produkte.",
    productdetailText: "Lagebericht: gesamter einsatz",
    replyblogText: "Interviewe deinen blog:",
    //个人中心 - 收货地址
    addseliveryaddressText: "Geben sie eine neue adresse für empfang ein",
    addaddresstitleText1: "Gespeichert.",
    addaddresstitleText2: "Eine adresse, die noch gespeichert wird",
    addaddresstitleText3: "Eine adresse.",
    defaultText: "Standard?",
    consigneeText: "Der empfänger",
    addressText: "Adresse:",
    fulladdressText: "Adressiert an:",
    setdefaultText: "Standard.",
    mobilephoneText: "Handy gesucht: blackie handy:",
    viewmoreText: "Ich will mehr sehen.",
    replypostText: "Antworte mal:",
    // 个人中心 - 个人信息
    nameLabel:"Namen, bitte?",
    sexlabel:"Geschlecht: männlich.",
    modifyavatarText:"Modifizieren sie den kopf.",
    sexmanText:"männer",
    sexwomanText:"die",
    secrecyText:"Geheimhaltung",
    replaceText:"Wechsel?",
    saveText:"Intakt?",
    oldpasswordText:"Der ursprüngliche code.",
    newpasswordText:"Neuer code.",
    confirmpasswordText:"Passwort bestätigt.",
    opdpleasolderText:"Bitte geben sie den originalcode ein",
    newpleasolderText:"Bitte geben sie ein neues passwort ein",
    unboundText:"ungebunden",
    bindingText:"Binde!",
    unbindingText:"Machen sie sie los.",
    // 个人中心-个人信息
    regionText:"Sage und schreibe.",
    addconsigneleasolderText:"Geben sie bitte den namen des empfängers ein",
    countrypleasolderText:"Such dir ein land aus.",
    provinceleasolderText:"Sparen sie sich das wort.",
    citypleasolderText:"Wählen sie den ort aus.",
    areapleasolderText:"Bitte wählen sie die zone aus.",
    fulladdressTextpleasolderText:"Bitte geben sie die genaue adresse ein",
    addconsignephoneleasolderText:"Geben sie bitte die telefonnummer des empfängers ein",
    emailpleasolderText:"Bitte geben sie eine e - mail -adresse ein",
    phoneText:'Sein handy.',
    uploadimgText:"Bild hochladen.",
    updateuserface:"Modifizieren sie den kopf.",
    uploadimgtitle1:"Unterstützung Von bildern im JPG, jpeg - und PNG -format",
    uploadimgtitle2:"Empfohlene größe: 200*200 Oder ein anderes bild",
    updateemailText:"Kontrolliere die emails.",
    updatemobileText:"Ich ändere die handynummer.",
    dialogemailtitle:"Ein postfach.",
    dialogmobiletitle:"Sein handy.",
    dialogheadertitle:" Geben sie hier die verbindungsdatei für ihren jde-account ein",
    continueText:"Machen sie weiter.",
    verificationinformation:"Daten bestätigt.",
    verificationinformationTitle1:"Um fortzufahren, beenden sie diesen authentifizierungsvorgang. Dem sind wir gefolgt.",
    verificationinformationTitle2:"Authentifizierungscode gesendet. Bitte geben sie es unten ein.",
    verificationcode:"Authentifizierungscode:",
    newtitle:"neue",
    dialognewmobiletitle:"Enter the new phone number to be associated. And click to confirm the replacement",
    confirmpbtnText:"Abschuss bestätigen.",
    titlecpuntryselect:"Welches land?",
    hotcountrytitle:"In einem beliebten land.",
    aboutusText:"Um uns.",
    // 订单详情
    havequestionsText:"Zweifel.",
    preferentialText:"Rabatt.",
    enquiryText:"Machen wir ein angebot.",
    combinationdiscountText:"Ein portfoliodeal.",
    introduceText:"Vorstellung.",
    buyermycommentsText:"Der käufer kommentiert das.",
    starText:"Star",
    yourmailboxText:"Ihr briefkasten.",
    placeholderquestionText:"Schreiben sie ihre frage auf",
    uploadimglimtText:"Rufen sie die JPG/GIF/PNG auf. Ng? 2MB sind nicht die größe.",
    submitbtnText:"Eingereicht werden",
    // 购物车
    selectText:"Durch unsere wahl.",
    tipscartsText:"Ausgewählte Produkte (ohne Fracht)",
    settlementText:"Abrechnung",
    selectallText:"Alle auswählen",
    amountText:"Geldbetrag",
    addtofavoritesText:"Favoriten hinzufügen",
    havecollectedText:"Favorit",
    tipdelecteproduct:"Sind Sie sicher, das aktuelle Element zu löschen?",
    deleteText:"löschen",
    tipclearcart:"Den einkaufswagen geräumt haben?",
    clearcartText:"Den einkaufswagen räumen",
    totalText:"Gesamtansicht.",
    totaltipText:"Fracht (ohne fracht):",
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_de.js